.headerContainer {
  border-bottom: 1px solid var(--static-divider-standard);
  background: var(--static-background-strong);
  display: flex;
  justify-content: center;
}
.headerContent {
  max-width: min(1800px, 100%);
  flex: 1;
  padding: 0 34px;
}
.pageContent {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 100vh;
  height: 100vh;
}
.bodyContainer {
  flex: 1;
  display: flex;
  justify-content: center;
  overflow: auto;
  width: 100%;
  max-width: 100%;
}
.bodyContent {
  max-width: min(1800px, 100%);
  padding: var(--page-content-padding);
  flex: 1;
  min-height: 0;
}
